import { AmplitudeProvider } from '@/analytics/amplitudeProvider';

import { ApiErrorBoundary } from '@/errorHandling/page/ApiErrorBoundary';
import ErrorFallback from '@/errorHandling/page/ErrorFallback';
import * as Sentry from '@sentry/react';
import { Outlet, createRootRoute } from '@tanstack/react-router';
// import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import type { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'react-hot-toast';

export const Route = createRootRoute({
  component: component,
  notFoundComponent: () => {
    return <ErrorFallback type="not_found" />;
  },
});

function component() {
  const onError = (error: Error, info: ErrorInfo) => {
    // sentry通知は自動的にキャプチャされる想定だが、確実にSentry通知するために明示的にcaptureExceptionを呼ぶ。
    Sentry.captureException(error, {
      captureContext: {
        contexts: { react: { ...info } },
      },
    });
    console.log('======= ErrorBoundary onError');
    console.log(error);
    console.log(info);
  };

  return (
    <>
      <ErrorBoundary
        FallbackComponent={() => <ErrorFallback type="normal" />}
        onError={onError}
      >
        <ApiErrorBoundary>
          <AmplitudeProvider>
            <Outlet />
          </AmplitudeProvider>
        </ApiErrorBoundary>
      </ErrorBoundary>

      {/* <TanStackRouterDevtools /> */}

      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 5000,
          success: {
            iconTheme: {
              primary: '#7ec718',
              secondary: '#fff',
            },
          },
        }}
      />
    </>
  );
}
